import React from 'react'

export default function Footer() {
    return (
        <footer className='bg-dark text-light fw-bold py-3'>
            
            Copyright &copy; My Todos List.com
        </footer>
    )
}
